// test1626
(1626 && 0);
